import { createDynamicSlice } from ".";
import { getNotificationListThunk } from "../thunks/notificationsThunk";

export const notificationsSlice = createDynamicSlice({
  name: "notifications",
  thunk: getNotificationListThunk,
  listMode: true,
  resetActionName: "resetNotifications",
});

export const notificationsReducer = notificationsSlice.reducer;
export const { resetNotifications } = notificationsSlice.actions;
